import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";

export interface CajaAperturaMovimientosQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
}

export async function getAllCajaActualAperturaMovimientos(aperturaId: string, query?: CajaAperturaMovimientosQuery): Promise<QueryResponse<CajaMovimiento>> {
    await sleep(1000);
    const response = await api.get("caja_actual/history/" + aperturaId + "/details", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajaActualAperturaMovimientosQuery(aperturaId: string, query: CajaAperturaMovimientosQuery = {}, queryConfig: QueryConfig<QueryResponse<CajaMovimiento>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajaActualAperturaMovimientos(aperturaId, query),
        queryKey: ["caja_actual", "history", aperturaId, "details", query],
    })
}

export interface GetAllCajaAperturaMovimientoQueryProps {
    aperturaId:string,
    query?: CajaAperturaMovimientosQuery,
    queryConfig?: QueryConfig<QueryResponse<CajaMovimiento>>,
    children: (queryResult: QueryResult<QueryResponse<CajaMovimiento>>) => ReactNode
}

export function GetAllCajaActualAperturaMovimientosQuery({
    aperturaId,
    query,
    queryConfig,
    children
}: GetAllCajaAperturaMovimientoQueryProps) {
    const queryResult = useGetAllCajaActualAperturaMovimientosQuery(aperturaId, query, queryConfig);
    return children && children(queryResult);
}